<template>
  <a-modal
    :title="null"
    :width="420"
    :visible="visible"
    :footer="null"
    @cancel="handleCancel"
  >
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="修改手机号码">
        <div class="pl-60 pr-60 pt-20">
          <a-form-model ref="form" :model="form1" :rules="loginRules1">
            <a-form-model-item prop="mobilePhone">
              <a-input v-model="form1.mobilePhone" placeholder="请输入新手机号码" />
            </a-form-model-item>
            <a-form-model-item prop="code">
              <a-input v-model="form1.code" type="验证码" placeholder="验证码">
                <CountDown slot="suffix" :count="60" @start="countDown" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-button
                class="w-100p"
                type="primary"
                :loading="formLoading"
                @click="postForm1"
              >
                确 认
              </a-button>
            </a-form-model-item>
          </a-form-model>

        </div>
      </a-tab-pane>
    </a-tabs>
  </a-modal>
</template>
<script>
import CountDown from '../CountDown'
import validate from '@framework/utils/biz-validate'

export default {
  components: {
    CountDown
  },
  props: {
    phone: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!validate.mobile.pattern.test(value)) {
        callback(new Error(validate.mobile.msg))
      } else {
        callback()
      }
    }

    return {

      loginRules1: {
        mobilePhone: [
          { required: true, trigger: 'blur', validator: validateMobile }
        ],
        code: [
          { required: true, trigger: 'blur', message: '请输入验证码' }
        ]
      },
      visible: false,
      confirmLoading: false,
      form1: {
        'mobilePhone': '',
        'code': ''
      },
      formLoading: false
    }
  },
  watch: {
    show(n) {
      this.visible = n
    },
    visible(n) {
      this.$emit('update:show', n)
    }
  },

  methods: {
    async countDown(count) {
      this.$refs.form.validateField('mobilePhone', async(err) => {
        if (!err) {
          const res = await this.$http({ ...this.$api.staffGetValidateCode, origin: true }, {
            mobilePhone: this.form1.mobilePhone
          })
          if (res.data.state === 'success') {
            count.next()
          } else {
            this.$message.error(res.data.msg)
          }
        }
      })
    },

    postForm1() {
      this.$refs.form.validate(async v => {
        if (v) {
          this.formLoading = true
          try {
            const res = await this.$http(this.$api.staffEditMobile, {
              'mobilePhone': this.form1.mobilePhone,
              'code': this.form1.code
            })
            if (res) {
              this.formLoading = false
              this.$message.success('修改手机号成功')
              this.visible = false
              this.$emit('success')
            }
            // setToken(res)
            // window.location.reload()
          } catch (error) {
            this.formLoading = false
          }
        }
      })
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
